<template>
  <div id="app">
    <div class="container">
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
        <h5>Upload Image</h5>
        <p>(in png, jpg format)</p>
        <div class="dropbox">
          <input
            type="file"
            multiple
            :name="uploadFieldName"
            :disabled="isSaving"
            @change="
              filesChange($event.target.name, $event.target.files)
              fileCount = $event.target.files.length
            "
            accept="image/*"
            class="input-file"
          />
          <p v-if="isInitial">
            Drag your image (in png or jpg format) here to begin<br />
            or click to browse
          </p>
          <p v-if="isSaving">Uploading {{ fileCount }} image...</p>
        </div>
      </form>
      <!--SUCCESS-->
      <div v-if="isSuccess">
        <p>
          <a href="javascript:void(0)" @click="reset()">Upload again</a>
        </p>
        <ul class="list-unstyled">
          <li v-for="(item, idx) in uploadedFiles" :key="idx">
            <img :src="item" class="img-responsive img-thumbnail custom-image" :alt="item.originalName" />
          </li>
        </ul>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h5>Upload failed.</h5>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
import * as axios from 'axios'
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
export default {
  name: 'dt-uploader',
  props: {
    endpoint: String,
    folder: String,
    query: String
  },
  data() {
    return {
      baseUrl: window.config ? window.config.apiUrl : '',
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'File'
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    wait(ms) {
      return (x) => {
        return new Promise((resolve) => setTimeout(() => resolve(x), ms))
      }
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      let api = `${this.baseUrl}/${this.endpoint}`
      if (this.query) {
        api += `?${this.query}`
      }
      return axios
        .post(api, formData)
        .then((x) => x.data)
        .then((x) => {
          var url = x
          this.uploadedFiles = [].concat(url)
          this.currentStatus = STATUS_SUCCESS
          this.$emit('finished')
        })
        .catch((err) => {
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange(fieldName, fileList) {
      // handle file changes
      let formData = new FormData()
      if (!fileList.length) return
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(fieldName, fileList[x], this.folder + fileList[x].name)
      })
      // save it
      this.save(formData)
    }
  },
  mounted() {
    this.reset()
  }
}
</script>
<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.custom-image {
  width: 300px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-uploader.vue